<template>
    <div>
        <!-- checkout form complete -->
        <div class="container"
            v-if="getCheckoutFormVisible && !orderCompletedVisible">
            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
                <div class="card-header">
                    <h3>1. Dados de Envio</h3>
                </div>
                <div class="card-body p-3 p-md-3">
                    <p>
                        Por favor, indique os seus dados pessoais para podermos
                        enviar as fotos selecionadas para si.
                    </p>
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <label>Nome <i class="mandatory"></i></label>
                            <input v-model="order.client_name"
                                required
                                type="text"
                                placeholder="Indique o seu nome"
                                class="form-control"
                                @blur="checkError($event, 'name')" />
                            <span class="error-message"
                                v-if="errors.name">O campo nome é obrigatório.</span>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <label>Morada<i class="mandatory"></i></label>
                            <input v-model="order.ship_address_1"
                                type="text"
                                required
                                placeholder="Indique a sua morada"
                                class="form-control"
                                @blur="checkError($event, 'address')" />
                            <input v-model="order.ship_address_2"
                                type="text"
                                placeholder="Complemento de morada"
                                class="form-control mt-1" />
                            <span class="error-message"
                                v-if="errors.address">O campo morada é obrigatório.</span>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-4 col-sm-4 col-lg-2">
                            <label>Cód. Postal<i class="mandatory"></i></label>
                            <input v-model="order.ship_zip_code"
                                type="text"
                                placeholder="XXXX-XXX"
                                class="form-control"
                                required
                                @blur="checkError($event, 'zip_code')" />
                            <span class="error-message"
                                v-if="errors.zip_code">Obrigatório.</span>
                        </div>
                        <div class="col-md-6 col-sm-8 col-lg-4">
                            <label>Localidade<i class="mandatory"></i></label>
                            <input v-model="order.ship_locality"
                                type="text"
                                placeholder="Indique a sua localidade"
                                class="form-control"
                                required
                                @blur="checkError($event, 'locality')" />
                            <span class="error-message"
                                v-if="errors.locality">Obrigatório.</span>
                        </div>
                        <div class="col-md-6 col-sm-8 col-lg-4">
                            <label>Cidade</label>
                            <input v-model="order.ship_city"
                                type="text"
                                placeholder="Indique a sua cidade"
                                class="form-control"
                                required />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-6 col-sm-12">
                            <label>E-mail <i class="mandatory"></i></label>
                            <input v-model="order.email"
                                type="email"
                                placeholder="Indique o seu e-mail"
                                class="form-control" />
                            <span class="error-message"
                                v-if="errors.email">O campo email é obrigatório.</span>
                            <small>Iremos notificá-lo através de e-mail quando a
                                suas fotos forem enviadas.</small>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label>Telefone/Telemóvel <i class="mandatory"></i></label>
                            <input type="text"
                                placeholder="Indique o seu telemóvel"
                                class="form-control"
                                v-model="order.phone" />
                            <span class="error-message"
                                v-if="errors.phone">O campo telefone/telemóvel é obrigatório.</span>
                            <small>Caso seja necessário contactá-lo</small>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <label>Observações</label>
                            <textarea class="form-control"
                                v-model="order.observations"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
                <div class="card-header">
                    <h3>2. O que vamos enviar</h3>
                </div>
                <div class="card-body p-3 p-md-4 items-review">
                    <div class="row mt-4 mb-4"
                        v-for="(item, index) in cart"
                        :key="index">
                        <div class="image col-12 col-md-4">
                            <img :src="item.image.thumbnail"
                                style=""
                                class="image-responsive" />
                        </div>
                        <div class="col-12 col-md-8">
                            <div class="row item-list">
                                <p><small>Cód. Interno #{{ item.image.id }}</small>
                                    <br>{{ item.image.original_filename }}
                                </p>
                            </div>
                            <div v-for="(size, sidx) in item.sizes"
                                :key="sidx"
                                class="row">
                                <div class="col-6">
                                    {{ size.quantity }} &times;
                                    {{ getImageSizeNameById(size.image_size_id) }}
                                </div>
                                <div class="col-6 text-right">
                                    {{ parseDecimalPlaces(size.line_price) }} &euro;
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 total">
                            <b>Total a Pagar </b>
                            <span class="ml-4 total-money">{{ parseDecimalPlaces(totalPrice) }} &euro;</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2 mb-4">
                <div class="card-header">
                    <h3>3. Método de Pagamento</h3>
                </div>
                <div class="card-body p-4">
                    <p> Por favor, selecione o método de pagamento mais cómodo para si.</p>
                    <div class="row mt-4">
                        <div class="col-3 text-center">
                            <img src="/assets/imgs/logo-mb-way.png"
                                height="60" />
                        </div>
                        <div class="col-9 mt-2">
                            <input id="check1"
                                type="radio"
                                class="form-check-input"
                                value="1"
                                v-model="order.payment_method_id" />
                            <label for="check1"
                                class="form-check-label">MB Way</label>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-3">
                            <img src="/assets/imgs/logo-transferencia.png"
                                height="40" />
                        </div>
                        <div class="col-9 mt-2">
                            <input id="check2"
                                type="radio"
                                class="form-check-input"
                                value="2"
                                v-model="order.payment_method_id" />
                            <label for="check2"
                                class="form-check-label">Transferência Bancária</label>
                        </div>
                    </div>
                    <!-- <div class="row mt-4">
                        <div class="col-3">
                            <img src="/assets/imgs/cobranca-logo.png"/>
                        </div>
                        <div class="col-9 mt-2">
                            <input
                                id="check3"
                                type="radio"
                                class="form-check-input"
                                value="3"
                                v-model="order.payment_method_id"
                            />
                            <label for="check3" class="form-check-label"
                            >Envio à Cobrança</label
                            >
                        </div>
                    </div> -->
                    <p class="mt-2 error-message"
                        v-if="!order.payment_method_id">
                        O método de pagamento é obrigatório.
                    </p>
                </div>
            </div>

            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2 mb-4">
                <div class="card-header">
                    <h3> 4. Concluir Encomenda </h3>
                </div>
                <div class="card-body mt-4">
                    <p>
                        Para concluir a sua encomenda, clique botão
                        <b>"Concluir Encomenda"</b>.
                    </p>
                    <p>
                        Após este passo, iremos processar o seu pedido e iremos
                        proceder à produção das fotografias que selecionou nos
                        respetivos tamanhos e iremos enviá-las para si.
                    </p>
                    <div class="text-center mt-5">
                        <b-overlay :show="isSaving">
                            <button type="button"
                                class="btn-primary btn"
                                :disabled="!isFormValid"
                                @click="placeOrder">
                                Concluir encomenda <i class="fa fa-check"></i>
                            </button>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>

        <!-- order complete -->
        <div class="container mb-5 mt-3"
            v-if="orderCompletedVisible">
            <div class="card">
                <div class="card-header">
                    <h3>Fantástico! Encomenda concluída</h3>
                </div>
                <div class="card-body">
                    <h5>Obrigado pela sua encomenda!</h5>
                    <div class="row mb-3">
                        <p>O código da sua encomenda é <b>{{ order.order_no }}</b></p>
                    </div>
                    <div class="row">
                        <h3 class="title mb-4">Método de pagamento</h3>
                        <div class="col-12 col-md-8 mt-2 m-auto"
                            v-if="order.payment_method_id == 1">
                            <div class="row">
                                <div class="col-12 col-md-3 mb-4">
                                    <img src="/assets/imgs/logo-mb-way.png"
                                        height="60" />
                                </div>
                                <div class="col-12 col-md-7">
                                    <h4 class="mb-2">Pagamento através de MB Way</h4>
                                    <p class="text-center text-md-left mb-4">
                                        Para concluir a sua encomenda, deverá
                                        fazer a transferência no valor de
                                        {{ parseDecimalPlaces(order.total) }}
                                        Euros para o número
                                        <b>{{ config.MBWAY_PHONE_NUMBER }}</b>, indicando o código da sua encomenda na
                                        descrição, conforme o exemplo abaixo.
                                    </p>
                                    <p class="text-center text-md-left">
                                        Iremos receber a notificação do seu pagamento e procederemos ao envio da sua
                                        encomenda tão rápido quanto possível.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 mt-2 m-auto"
                            v-if="order.payment_method_id == 2">
                            <div class="row">
                                <div class="col-2">
                                    <img src="/assets/imgs/logo-transferencia.png"
                                        height="60" />
                                </div>
                                <div class="col-10">
                                    <h4>
                                        Pagamento através de Transferência Bancária
                                    </h4>
                                    <p> Para concluir a sua encomenda, deverá fazer a transferência bancária no valor de
                                        {{ parseDecimalPlaces(order.total) }} Euros para o IBAN
                                        <b>{{ config.BANK_ACCOUNT_IBAN }}</b>, indicando o código da sua encomenda na
                                        descrição, da transferência
                                    </p>
                                    <p> Iremos receber a notificação do seu pagamento e procederemos ao envio da sua
                                        encomenda tão rápido quanto possível.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-xl-7 mt-2 m-auto"
                            v-if="order.payment_method_id == 3">
                            <div class="row">
                                <div class="col-2">
                                    <img src="/assets/imgs/cobranca-logo.png"
                                        height="60" />
                                </div>
                                <div class="col-10">
                                    <h4>Pagamento à Cobrança</h4>
                                    <p> E pronto! Não necessita de fazer mais nada! </p>
                                    <p> Iremos processar a sua encomenda brevemente e proceder ao seu envio tão rápido
                                        quanto possível. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-8 col-md-10 col-sm-12 m-auto mt-5">
                            <p class="text-center">
                                Qualquer dúvida ou questão, por favor, contacte-nos através do nosso e-mail para <a
                                    :href="`mailto:${config.ACCOUNTING_EMAIL}`">{{ config.ACCOUNTING_EMAIL }}</a> ou
                                através do telefone
                                <a :href="`tel:${config.SITE_PHONE}`">{{ config.SITE_PHONE }}</a>
                            </p>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <hr />
                        <div class="col-md-4 m-auto text-center mt-3">
                            <button class="btn btn-outline-primary"
                                @click="showGallery"> Voltar à galeria</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import OrderAPI from "../api/OrderAPI.js";

    export default {
        name: "CartFormComponent",
        props: {
            gallery: {
                type: Object
            }
        },
        data() {
            return {
                isSaving: false,
                errors: {
                    name: false,
                    address: false,
                    ship_zip_code: false,
                    ship_locality: false,
                    email: false,
                    phone: false,
                },
                formValidated: false,
                order: {
                    gallery_id: null,
                    client_name: "",
                    ship_address_1: "",
                    ship_address_2: "",
                    ship_address_3: "",
                    ship_zip_code: "",
                    ship_locality: "",
                    city: "",
                    ship_same_address: true,
                    total: 0.0,
                    payment_method_id: null,
                    phone: "",
                    email: "",
                },
                config: {},
            };
        },
        methods: {
            getImageSizeNameById(image_size_id) {
                const size = this.imageSizes.find(
                    (elem) => elem.id === image_size_id
                );
                if (size) {
                    return size.name;
                }
                return "";
            },
            parseDecimalPlaces(value) {
                return Number(
                    Math.round(parseFloat(value + "e" + 2)) + "e-" + 2
                ).toFixed(2);
            },
            // check input for error
            checkError(event, field) {
                this.formValidated = true;
                if (event.target.value.toString().length < 3) {
                    this.errors[field] = true;
                } else {
                    this.errors[field] = false;
                }
                this.validateForm();
            },

            validateForm() {

                if (this.order.payment_method_id === undefined) {
                    console.log('Check payment method');
                    return false;
                }

                if (
                    this.order.email.length < 3 ||
                    this.order.client_name.length < 3 ||
                    this.order.ship_address_1.length < 3 ||
                    this.order.ship_zip_code.length < 3 ||
                    this.order.ship_locality.length < 3 ||
                    this.order.email.length < 3 ||
                    this.order.phone.length < 9) {
                    console.log('Check Client Data');
                    return false
                }

                return true;
            },

            // create order
            placeOrder() {
                this.isSaving = true;
                let self = this;
                let orderAPI = new OrderAPI();

                let newOrder = this.order;
                newOrder.order_lines = this.cart;
                newOrder.gallery_id = this.gallery.id;
                orderAPI
                    .store(newOrder)
                    .then((res) => {
                        if (res.status === 201) {
                            self.$store.dispatch("updateOrder", res.data.data);
                            self.isSaving = false;
                            self.$store.dispatch("hideCheckoutForm");
                            self.$store.dispatch("setOrderCompleteVisible", true);
                            // clean up cart
                            self.$store.dispatch("emptyCart");
                            self.order = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            showGallery() {

                // limpar a encomenda se já tiver id
                if (this.order.id !== null) {
                    this.order = {
                        client_name: '',
                        ship_address_1: '',
                        ship_address_2: '',
                        ship_address_3: '',
                        ship_zip_code: '',
                        ship_locality: '',
                        ship_city: '',
                        ship_same_address: true,
                        total: 0.0,
                        payment_method_id: null,
                        phone: '',
                        email: '',
                    }
                }

                this.$store.dispatch("showGallery");
                var element = document.getElementsByClassName("gallery");
                var top = element.offsetTop;
                window.scrollTo(0, top);
                this.$store.dispatch("setOrderCompleteVisible", false);
                this.$store.dispatch("resetOrder");
            },

        },
        computed: {
            isFormValid() {
                return this.validateForm();
            },
            ...mapGetters({
                getCheckoutFormVisible: "getCheckoutFormVisible",
                orderCompletedVisible: "orderCompletedVisible",
                cart: "getCart",
                imageSizes: "imageSizes",
                totalPrice: "getTotalPrice",
            }),
        },
        watch: {
            order: {
                deep: true,
                handler: function () {
                    this.$store.dispatch("updateOrder", this.order);
                },
            },
        },
        mounted() {
            const order = this.$store.getters.getOrder;
            if (order) {
                this.order = { ...this.order, ...order };
            }
            this.order.gallery_id = this.gallery.id;

            this.validateForm();

            // get configs
            this.config = {
                BANK_ACCOUNT_IBAN: 'PT50 0033 0000 4523 7064 2400 5',
                ACCOUNTING_EMAIL: 'fdmarques@gmail.com',
                SITE_PHONE: '+351256193930',
                SITE_PHONE_FOR_HUMANS: '256 193 930',
                MBWAY_PHONE_NUMBER: '+351965229796'
            }
        },
    };
</script>
